import {
  CANCELLATION_REMARKS_FOR_VENDOR,
  CANCELLATION_REMARKS_FOR_VENDOR_SUCCESS,
  CANCELLATION_REMARKS_FOR_VENDOR_ERROR,
  CANCELLATION_REMARKS_FOR_VENDOR_EMPTY,
} from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CancellationRemarksForVendor = (state = initialState, action) => {
  switch (action.type) {
    case CANCELLATION_REMARKS_FOR_VENDOR:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CANCELLATION_REMARKS_FOR_VENDOR_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CANCELLATION_REMARKS_FOR_VENDOR_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CANCELLATION_REMARKS_FOR_VENDOR_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CancellationRemarksForVendor;
